import { wipeAllLocalData } from './wipeAllLocalData';

export const wipeCognitoArtifactsExceptFor = (authClientId: string) => {
  wipeAllLocalData(
    (key) =>
      key.startsWith(`CognitoIdentityServiceProvider`) &&
      !key.startsWith(`CognitoIdentityServiceProvider.${authClientId}`),
  );
};
